var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 5.75,
    width: 20.5,
    height: 20.5,
    rx: 3.25,
    stroke: "#E8F2FF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.4459H17",
    stroke: "#E8F2FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.4459H22",
    stroke: "#E8F2FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3573 14.3097C16.3573 12.7797 17.4373 11.6697 18.9973 11.6697C20.0473 11.6697 20.8773 12.1797 21.2673 13.0597L20.2973 13.5697C20.0473 13.0197 19.5873 12.7197 18.9973 12.7197C18.1073 12.7197 17.5073 13.3897 17.5073 14.3097C17.5073 15.2297 18.1073 15.8997 18.9873 15.8997C19.5873 15.8997 20.0573 15.5897 20.2973 15.0097L21.2873 15.4997C20.8973 16.4197 20.0573 16.9497 18.9873 16.9497C17.4373 16.9497 16.3573 15.8397 16.3573 14.3097Z",
    fill: "#E8F2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7128 14.3097C10.7128 12.7797 11.7928 11.6697 13.3528 11.6697C14.4028 11.6697 15.2328 12.1797 15.6228 13.0597L14.6528 13.5697C14.4028 13.0197 13.9428 12.7197 13.3528 12.7197C12.4628 12.7197 11.8628 13.3897 11.8628 14.3097C11.8628 15.2297 12.4628 15.8997 13.3428 15.8997C13.9428 15.8997 14.4128 15.5897 14.6528 15.0097L15.6428 15.4997C15.2528 16.4197 14.4128 16.9497 13.3428 16.9497C11.7928 16.9497 10.7128 15.8397 10.7128 14.3097Z",
    fill: "#E8F2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.da2a8684c70e96c030d7997b27fa701a.svg";
export { ForwardRef as ReactComponent };